import styles from './LoadingDataProgress.module.scss'

interface LoadingDataProgressProps {
  loaded: number
  total: number
}

export const LoadingDataProgress = ({
  loaded,
  total,
}: LoadingDataProgressProps) => (
  <div className={styles.loadingContainer}>
    <h1 className="mt-2 font-weight-bold">
      {Math.round((loaded / total) * 100)}%
    </h1>
  </div>
)
